import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const AddOrderPage = lazy(() => import('./AddOrderPage'));

const AddOrderConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Orders,
  routes: [
    {
      path: 'orders/add',
      element: <AddOrderPage />,
    },
  ],
};

export default AddOrderConfig;
